const Department = {
  ODRZAVANJEVIK: { label: 'Održavanje ViK', value: 0 },
  PROIZVODNJAIDISTRIBUCIJA: { label: 'Proizvodnja i distribucija', value: 1 },
  ZAJEDNICKESLUZBE: { label: 'Zajedničke službe', value: 2 },
};

export default Department;
